import { getLoggedInUser } from '@/store/auth/thunks/getLoggedInUser.ts'
import { setLoggedOut } from '@/store/auth/thunks/setLoggedOut.ts'
import { DefaultRootState } from '@/store/coreReducer.ts'
import { stateREHYDRATE } from '@/store/stateREHYDRATE.ts'
import { LoginResponseDto } from '@/types/auth.ts'
import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface InitialAuthState {
	user: LoginResponseDto | undefined
}

const initialState: InitialAuthState = {
	user: undefined,
}

/**
 * !!! WARNING !!!
 *  Do not add thunks to change any of this data during the normal operation of the application.
 * !!! WARNING !!!
 *
 * The Subscription middleware relies on the fact that when the setUserData action gets called it sets up
 * other subscriptions to manage the users other data.
 */
const _doNotUseSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		// setUserData: (state, action: PayloadAction<IUserData>) => {
		// 	state.user = action.payload
		// },
		// clearUserData: state => {
		// 	state.user = undefined
		// },
	},
	extraReducers: builder => {
		builder.addCase(stateREHYDRATE.fulfilled, (state, action: PayloadAction<Partial<DefaultRootState>>) => {
			if (action.payload['auth']) {
				state.user = action.payload['auth'].user
			}
		})
		builder.addCase(getLoggedInUser.fulfilled, (state, action) => {
			state.user = action.payload
		})
		builder.addCase(setLoggedOut.fulfilled, state => {
			state.user = undefined
		})
	},
})

// export const { setUserData, clearUserData } = _doNotUseSlice.actions

export default _doNotUseSlice.reducer
